export default __webpack_public_path__ + "static/media/selecta_small.68a560b6.jpg";